import { createFileRoute } from '@tanstack/react-router'

import { getFontLanguage } from '@/utils/get-font-language'

export const Route = createFileRoute('/$country/$language')({
  head: ({ params }) => {
    const fontLang = getFontLanguage(params.country, params.language)
    return {
      links: [
        {
          href: `https://ikea.marat.qd.je/global/assets/fonts/${fontLang}/fonts.css`,
          rel: 'stylesheet',
        },
      ],
    }
  },
})
